import * as SerializerLib from "jsonapi-serializer";

import { serializeError } from "../base.serializer";

const JSONAPISerializer = SerializerLib.Serializer;

const opts = {
  attributes: ["optionId"]
};

export const serialize = (data: { optionId?: string | number | null }) => {
  try {
    const Serializer = new JSONAPISerializer("quick-poll", opts);
    return Serializer.serialize(data);
  } catch (err) {
    return serializeError(err);
  }
};
